import axios from "Services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getDashboard = createAsyncThunk("dashboard/getDashboard", async (thunkAPI) => {
  try {
    const response = await axios.get(`/GetDashboard`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const getTodayStreakScore = createAsyncThunk("dashboard/getTodayStreakScore", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/GetTodayStreakScore`, data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const getStreakScore = createAsyncThunk("dashboard/getStreakScore", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/GetStreakScore`, data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const updateStreakMode = createAsyncThunk("dashboard/updateStreakMode", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/UpdateStreakMode`, data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});
